import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import qs from 'qs';
import Dropdown from '@/react/shared/Dropdown';
import SearchInput from '@/react/shared/SearchInput';

const I18n = {
  cont: 'Continue',
  select_a_company: 'Select a Company'
};

let companyCounter = 0;

class CompanyPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      companyId: null,
      searchValue: '',
    };

    this.handleSearch = this.handleSearch.bind(this);
  }

  setCompanyId(companyId) {
    this.setState({ companyId });
  }

  handleSearch(searchValue) {
    this.setState({searchValue});
  }

  renderCompanies() {
    const { companies } = this.props;
    const { searchValue } = this.state;
    return companies.filter(company => (company.name.toLowerCase().indexOf(searchValue.toLowerCase()) === 0)).map((company) => (
      /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
      <a
        onClick={ () => this.setCompanyId(company.id) }
        className='dropdown-item'
        key={`${company.name}-${company.id}-${companyCounter++}`}
      >
        {company.name}
      </a>
    ))
  }

  render() {
    const { linkTo, companies } = this.props;
    const { companyId } = this.state;
    const disabled = !companyId;

    const selectedCompany = companies.find((c) => (c.id == companyId));

    let continuePath;
    if (selectedCompany) {
      const params = {
        'company_id': selectedCompany.id,
        'company_name': selectedCompany.name,
        'company_root': selectedCompany.procore_root,
      };

      continuePath = `${linkTo}?${qs.stringify(params)}`;
    }

    return (
      <>
        <Dropdown
          className='company-picker'
          closeOnSelect
          dropdownDirection='south'
          dropdownTarget={
            <span className={cx('dropdown-default-target','company-select-dropdown')}>
              <div className='dropdown-text'>
                {
                  selectedCompany ?
                    selectedCompany.name :
                    I18n.select_a_company
                }
              </div>
              <div className='dropdown-icon fa fa-chevron-down'/>
            </span>
          }
        >
          <SearchInput
            onSearchChange={this.handleSearch}
          />
          {this.renderCompanies()}
        </Dropdown>
        <a
          href={continuePath}
          className={cx('button-continue', 'primaryButton', { disabled })}
        >
          {I18n.cont}
        </a>
      </>
    );
  }
}

CompanyPicker.propTypes = {
  companies: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      procore_root: PropTypes.string,
    })
  ),
  linkTo: PropTypes.string,
};

export default CompanyPicker;
